import React, { useMemo, useState, Component } from 'react';
const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    inquiryType: '',
    message: ''
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  // Create the mailto link with encoded subject and body
  const mailtoLink = useMemo(() => {
    const subject = `New Inquiry from ${formData.name} - ${formData.inquiryType}`;
    const body = `
Name: ${formData.name}
Email: ${formData.email}
Phone: ${formData.phone}
Inquiry Type: ${formData.inquiryType}
Message:
${formData.message}
---
Sent via Israeli Civilian Training Foundation Contact Form
    `.trim();
    return `mailto:tim@internationalciviliantraining.org?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  }, [formData]);
  const isFormValid = formData.name && formData.email && formData.inquiryType && formData.message;
  return <form className="space-y-4 sm:space-y-6 font-light" data-id="element-57">
      <div data-id="element-58">
        <label htmlFor="name" className="block text-gray-700 mb-2 sm:mb-2.5 font-light text-sm sm:text-base" data-id="element-59">
          Name
        </label>
        <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required className="w-full px-4 sm:px-5 py-2.5 sm:py-3 bg-white border border-gray-300 rounded-lg text-gray-700 focus:outline-none focus:ring-2 focus:ring-israel-blue focus:border-transparent font-light text-sm sm:text-base" data-id="element-60" />
      </div>
      <div data-id="element-61">
        <label htmlFor="email" className="block text-gray-300 mb-1.5 sm:mb-2 font-light text-sm sm:text-base" data-id="element-62">
          Email
        </label>
        <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required className="w-full px-3 sm:px-4 py-1.5 sm:py-2 bg-white border border-gray-300 rounded-lg text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 font-light text-sm sm:text-base" data-id="element-63" />
      </div>
      <div data-id="element-64">
        <label htmlFor="phone" className="block text-gray-300 mb-1.5 sm:mb-2 font-light text-sm sm:text-base" data-id="element-65">
          Phone
        </label>
        <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} className="w-full px-3 sm:px-4 py-1.5 sm:py-2 bg-white border border-gray-300 rounded-lg text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 font-light text-sm sm:text-base" data-id="element-66" />
      </div>
      <div data-id="element-67">
        <label htmlFor="inquiryType" className="block text-gray-300 mb-1.5 sm:mb-2 font-light text-sm sm:text-base" data-id="element-68">
          Reason for Contact
        </label>
        <select id="inquiryType" name="inquiryType" value={formData.inquiryType} onChange={handleChange} required className="w-full px-3 sm:px-4 py-1.5 sm:py-2 bg-white border border-gray-300 rounded-lg text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 font-light text-sm sm:text-base" data-id="element-69">
          <option value="" data-id="element-70">Select a reason</option>
          <option value="Donate" data-id="element-71">Donate</option>
          <option value="Volunteer" data-id="element-72">Volunteer</option>
          <option value="Press" data-id="element-73">Press</option>
          <option value="Other" data-id="element-74">Other</option>
        </select>
      </div>
      <div data-id="element-75">
        <label htmlFor="message" className="block text-gray-300 mb-1.5 sm:mb-2 font-light text-sm sm:text-base" data-id="element-76">
          Message
        </label>
        <textarea id="message" name="message" value={formData.message} onChange={handleChange} rows={4} required className="w-full px-3 sm:px-4 py-1.5 sm:py-2 bg-white border border-gray-300 rounded-lg text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 font-light text-sm sm:text-base" data-id="element-77"></textarea>
      </div>
      <div data-id="element-78">
        <a href={isFormValid ? mailtoLink : '#'} onClick={e => {
        if (!isFormValid) {
          e.preventDefault();
          alert('Please fill out all required fields before submitting.');
        }
      }} className={`block w-full px-4 sm:px-6 py-2 sm:py-3 text-center bg-israel-blue text-white font-light rounded-lg transition-all transform hover:scale-105 text-sm sm:text-base ${!isFormValid ? 'opacity-50 cursor-not-allowed' : 'hover:bg-israel-blue-light'}`} data-id="element-79">
          Submit
        </a>
      </div>
    </form>;
};
export default ContactForm;